import { Injectable } from '@angular/core';
import { ApiEndpointConfigService, ApiEndpointService } from '@rci/self-serve-shared';
import { NEW_OFFERS_API, PPC_FLOW_URL } from '@rci/self-serve-fido/app.constant';

@Injectable()
export class TargetedOffersConfigServiceFactory {
  applicationId = 'Fido.ca';

  constructor(
    private readonly apiConfig: ApiEndpointService,
    private readonly apiEndpointConfigService: ApiEndpointConfigService,
  ) {}

  get api() {
    return {
      buyflowApiBaseUrl: '/bfa-api/',
      viewOfferUrl: this.apiEndpointConfigService.oneClickPpcUrl,
    };
  }

  get moreOffersUrl() {
    return PPC_FLOW_URL;
  }

  get baseApiUrl(): string {
    return `${this.apiConfig.promotionsBaseUrl}accounts/`;
  }

  get brtSwitchId(): string {
    return NEW_OFFERS_API;
  }

  get contentPageName() {
    return 'overview';
  }
}
